import { render } from "./RememberFace.vue?vue&type=template&id=2cea7cac&scoped=true"
import script from "./RememberFace.vue?vue&type=script&lang=js"
export * from "./RememberFace.vue?vue&type=script&lang=js"

import "./RememberFace.vue?vue&type=style&index=0&id=2cea7cac&scoped=true&lang=css"

import exportComponent from "/home/lyramdc/Projects/face/ACE-face-name-test/v-face-memory/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cea7cac"]])

export default __exports__